import { NgModule } from "@angular/core";
import { LocalStorageRepositoryInterface } from "./local-storage.interface";
import { LocalStorageRepository } from "./local-storage.repository";

@NgModule({
  providers: [
    { provide: LocalStorageRepositoryInterface, useClass : LocalStorageRepository }
  ]
})
export class LocalStorageRepositoryModule {}